import React from "react";
import { ASSETS } from "../lib/api";
import { useT } from "../i18n/LanguageContext";

export const Legacy = () => {
  const { t } = useT();
  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative"
      style={{ background: "#1B3022" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 flex justify-center">
          <div className="relative">
            <div className="absolute -inset-8 rounded-full bg-[#D4AF37]/10 blur-3xl" />
            <img
              src={ASSETS.crest}
              alt="HBS legacy"
              className="relative max-h-[420px] w-auto object-contain bg-white rounded-sm p-8"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-3 ornament">
            {t("legacy.eyebrow")}
          </div>
          <h2 className="font-serif-bv text-4xl sm:text-5xl lg:text-6xl text-[#F5EFE0] leading-[1.05]">
            {t("legacy.title_1")} <span className="italic text-[#D4AF37]">{t("legacy.title_italic")}</span> {t("legacy.title_2")}
          </h2>
          <p className="mt-7 text-[#F5EFE0]/85 leading-relaxed text-base sm:text-lg max-w-2xl">
            {t("legacy.body")}
          </p>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-6">
            {[
              { k: t("legacy.value1_k"), v: t("legacy.value1_v") },
              { k: t("legacy.value2_k"), v: t("legacy.value2_v") },
              { k: t("legacy.value3_k"), v: t("legacy.value3_v") },
            ].map((p) => (
              <div key={p.k} className="border-l-2 border-[#D4AF37] pl-4">
                <div className="font-serif-bv text-2xl text-[#D4AF37]">{p.k}</div>
                <div className="text-xs tracking-wide text-[#F5EFE0]/70 mt-1">{p.v}</div>
              </div>
            ))}
          </div>

          <p className="font-serif-bv italic text-3xl text-[#D4AF37] mt-12">
            "Liberté ou la Mort."
          </p>
          <p className="text-xs tracking-[0.3em] uppercase text-[#F5EFE0]/60 mt-2">
            {t("legacy.motto_caption")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Legacy;
